import React, { useEffect, useState } from "react";
import { Intent } from "@blueprintjs/core";
import { NotificationToaster } from "components/notifications";
import { LicenceCheckingService } from "services";
import { UserAccess } from "components/user-access";
import { LinkButton } from "components/buttons";
import { useDispatch, useSelector } from "react-redux";
import { Numeric } from "components/formatting";
import classNames from "classnames";
import PropTypes from "prop-types";
import { ShowHide } from "components/layout";

const manageCreditsActions = [
    "LicenceChecking:Manage",
    "LicenceChecking:View",
    "LicenceChecking:GreyFleet",
];

export function CreditCount({
    from = "",
    hideManageButton = false
}) {
    const licenceCredits = useSelector(
        (state) => state.licenceChecking.licenceCredits
    );
    const greyFleetCredits = useSelector(
        (state) => state.licenceChecking.greyFleetCredits
    );
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();

    useEffect(() => {
        getCredits();
    }, []);

    function getCredits() {
        LicenceCheckingService.getCredits()
            .then(
                (result) => {
                    dispatch({
                        type: "SET_LICENCE_CREDITS",
                        payload: result.licenceCredits,
                    });
                    dispatch({
                        type: "SET_GREY_FLEET_CREDITS",
                        payload: result.greyFleetCredits,
                    });
                },
                () => {
                    NotificationToaster.show(
                        Intent.DANGER,
                        "Unable to get credit count, please try again."
                    );
                }
            )
            .catch(() => {
                NotificationToaster.show(
                    Intent.DANGER,
                    "Unable to get credit count, please try again."
                );
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <div className="inline-items space-large">
            <div className="inline-item text-align-right">
                <h6 className="no-margin">LICENCE CREDITS</h6>
                <p
                    className={classNames("no-margin semi-bold", {
                        "bp6-skeleton": isLoading,
                    })}
                >
                    <Numeric>{licenceCredits}</Numeric>
                </p>
            </div>
            <div className="inline-item text-align-right">
                <h6 className="no-margin">GREY FLEET CREDITS</h6>
                <p
                    className={classNames("no-margin semi-bold", {
                        "bp6-skeleton": isLoading,
                    })}
                >
                    <Numeric>{greyFleetCredits}</Numeric>
                </p>
            </div>
            <ShowHide
                evaluator={!hideManageButton}
                show={
                    <UserAccess
                        perform={manageCreditsActions}
                        yes={() => (
                            <div className="inline-item">
                                <LinkButton
                                    text="Manage Credits"
                                    intent="primary"
                                    href={`/licence-checking/credits?from=${from}`}
                                />
                            </div>
                        )}
                    />
                }
            />
        </div>
    );
}

CreditCount.propTypes = {
    from: PropTypes.string,
    hideManageButton: PropTypes.bool,
};
